// @ts-expect-error TS(7016): Could not find a declaration file for module 'hype... Remove this comment to see the full error message
import { serialize } from 'hypernova';

import { SsrProps } from 'ssr/types/SsrProps';

type Args = {
  name: string;
  ssrProps: SsrProps;
  html: string;
  styleTags: string;
};

export function ssrHypernovaSerializePayload({
  name,
  ssrProps,
  html,
  styleTags,
}: Args) {
  const markup = serialize(name, html, {
    config: ssrProps.config,
    state: ssrProps.state,
  });

  return `${styleTags}\n${markup}`;
}
